import styled from '@emotion/styled';
import SearchMarvin from "@assets/svg/search_marvin.svg"
import { fontWeight, mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';
import { colors } from '@styles/colors';
import Arrow_Icon from "@assets/svg/d-arrow.svg";
import M_Arrow_Icon from "@assets/svg/m-arrow.svg";
import Lottie from 'react-lottie-player';
import Marvin_Json from '@lotties/sherlock.json'

const ErrorContainer = styled.div`
  width:100%;
  height: calc(100vh - var(--header-height) - var(--regi-nav-height));
  display:flex;
  justify-content: center;
  align-items: center;
  padding:30px;
`;

const CenterDiv = styled.div`
  position: relative;
  padding-top:50px;
  height:80%;
  

  > svg{
    height:100%;
  }

  ${mq(Devices.laptop)} {
    display:flex;
    flex-direction: column;
    height:80%;

    > svg{
      height:100%;
      max-height: 250px;
    }
  }
  ${mq(Devices.mobile)} {
    padding-left:10px;
    padding-right:10px;
  } ;
`;


export const Attention = styled.h1`
  color: ${colors.darkenedBlue};
  font-weight: ${fontWeight.bold};
  font-size: 24px;
  line-height: 1.1;
  text-align: center;

  ${mq(Devices.laptop)} {
    font-size: 20px;
  }

  ${mq(Devices.tablet)} {
    font-size: clamp(18px, 4vw, 20px);
  }
`;

export const TextBubble = styled.div`
  position: absolute;
  max-width:500px;
  width:90vw;
  bottom:63%;
  left:50%;
  padding:20px ;
  background:#fff;
  border-radius:20px;
  box-shadow: 0 0 10px rgba(0,0,0,0.25);
  

  svg:nth-of-type(1){
    height:100px;
    position: absolute;
    top:99%;
    left:70px;
    filter: drop-shadow(0px 3px 2px rgb(0 0 0 / 0.2));
  }
  
  svg:nth-of-type(2){
    display:none;
  }

  ${mq(Devices.laptop)} {
    position: relative;
    bottom:unset;
    left:unset;
    margin-bottom: -70px;

    svg:nth-of-type(1){
      display:none;
    }

    svg:nth-of-type(2){
      display: unset;
      height:100px;
      position: absolute;
      top:99%;
      right:30%;
      filter: drop-shadow(0px 4px 2px rgb(0 0 0 / 0.2));
    }
  }

`;

export const LottieWrapper = styled.div`
  height:100%;

  > div {
    pointer-events: none;
  }
`;


export const ScheduleErrorContainer = ({ error, textOnly=false }) => {

  const SherlockMarvin = {
    loop: true,
    animationData: Marvin_Json,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return <ErrorContainer>
      <CenterDiv>
        {textOnly?<Attention>{error.schedule ? error.schedule : error.students ? error.students : `Something has crashed the system`}</Attention>:<><TextBubble>
          <Attention> {error.schedule ? error.schedule : error.students ? error.students : `Something has crashed the system`}</Attention>
          <Arrow_Icon />
          <M_Arrow_Icon />
        </TextBubble>
        <LottieWrapper>
          <Lottie {...SherlockMarvin} play style={{width:'100%',height:'100%',overflow:'hidden',margin:'0 auto'}} />
        </LottieWrapper></>}
        
        {/* <SearchMarvin /> */}
      </CenterDiv>
    </ErrorContainer>
};

export default ScheduleErrorContainer;